// NOTE: AUTO GENERATED FILE! Do not modify directly!

export enum IconsEnum {
  'affiliate' = 'affiliate',
  'aiAssistant' = 'aiAssistant',
  'arrowDown' = 'arrowDown',
  'arrowLeft' = 'arrowLeft',
  'arrowPN' = 'arrowPN',
  'arrowRight' = 'arrowRight',
  'arrowUp' = 'arrowUp',
  'bell' = 'bell',
  'billing' = 'billing',
  'boost' = 'boost',
  'browser' = 'browser',
  'call' = 'call',
  'canva' = 'canva',
  'carousel' = 'carousel',
  'chart' = 'chart',
  'clicks' = 'clicks',
  'clipboard' = 'clipboard',
  'comments' = 'comments',
  'crown' = 'crown',
  'cycleLength' = 'cycleLength',
  'cycles' = 'cycles',
  'debugger' = 'debugger',
  'delay' = 'delay',
  'download' = 'download',
  'dragHandle' = 'dragHandle',
  'duplicate' = 'duplicate',
  'edit' = 'edit',
  'emoji' = 'emoji',
  'exclamation' = 'exclamation',
  'facebook' = 'facebook',
  'filter' = 'filter',
  'folder' = 'folder',
  'gifBadge' = 'gifBadge',
  'google' = 'google',
  'grabHandle' = 'grabHandle',
  'hashtag' = 'hashtag',
  'help' = 'help',
  'igSave' = 'igSave',
  'igSend' = 'igSend',
  'import' = 'import',
  'impressions' = 'impressions',
  'info' = 'info',
  'iteration' = 'iteration',
  'likes' = 'likes',
  'link' = 'link',
  'logout' = 'logout',
  'mail' = 'mail',
  'mobile' = 'mobile',
  'moveUp' = 'moveUp',
  'multidate' = 'multidate',
  'noData' = 'noData',
  'pause' = 'pause',
  'photo' = 'photo',
  'pin' = 'pin',
  'play' = 'play',
  'plus' = 'plus',
  'preferences' = 'preferences',
  'queued' = 'queued',
  'reGenerate' = 'reGenerate',
  'retweets' = 'retweets',
  'search' = 'search',
  'settings' = 'settings',
  'share' = 'share',
  'snippet' = 'snippet',
  'subscription' = 'subscription',
  'target' = 'target',
  'team' = 'team',
  'threads' = 'threads',
  'threeDot' = 'threeDot',
  'thumbUp' = 'thumbUp',
  'tick' = 'tick',
  'trash' = 'trash',
  'triangleDown' = 'triangleDown',
  'triangleWarning' = 'triangleWarning',
  'upload' = 'upload',
  'userProfile' = 'userProfile',
  'variation' = 'variation',
  'video' = 'video',
  'videoViews' = 'videoViews',
  'whatsNew' = 'whatsNew',
  'youtube' = 'youtube'
}
